import Validation from '../../../Utilities/ValidationHelper/Validation';
import { validateStringExists } from '../../../Utilities/ValidationHelper/validationHelpers';

export default class ValidatePlacements extends Validation {
  static affiliate = (value) => {
    const result = { ...ValidatePlacements.defaultReturn };
    if (value.trim() === '') {
      result.valid = false;
      result.message = 'Value for Affiliate can not be empty.';
    }
    return result;
  };

  static site = (value) => {
    const result = { ...ValidatePlacements.defaultReturn };
    if (!+value) {
      result.valid = false;
      result.message = 'Please select a vertical.';
    }
    return result;
  };

  static placementID = (value) => {
    const result = { ...ValidatePlacements.defaultReturn };
    if (!(validateStringExists(value) && value.length === 30)) {
      result.valid = false;
      result.message =
        'Placement ID should not be less or more than 30 characters long.';
    }
    return result;
  };
}
